import React, { useContext, useEffect, useState, useMemo } from 'react'
import { Row, Col, Form, Image } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import httpClient, { getBaseURL } from 'utility/httpClient.util'
import Label from './Label'
import { Avatar } from '@material-ui/core'
import axios from 'axios'
import { checkSearchField } from '../action/Search'

const CustomImage = (props) => {
  let { uischema, config } = props
  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setFormData,
    designerProps,
    elementAction = {},
    setFieldFormData,
    setFieldSearchData,
    setFieldAllData,
    isUiChanged,
    setIsUiChanged,
  } = designContext
  let formData = objectPath.get(jsonForm, 'formData')
  let action = objectPath.get(uischema, 'action')
  let actionName = objectPath.get(action, 'name')

  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicData = {},
    onUpdateFormData = () => {},
    isArray,
    arrayName,
  } = config

  const uiKey = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name',
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name,
        )
        if (uiName) {
          return uiName.systemName
        }
      }
      return uischema.name
    }
    return uischema.key
  }, [isDynamic])

  const uiName = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name',
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name,
        )
        if (uiName) {
          return uiName.systemName
        }
      }
    }
    if (isArray) {
      return `@${arrayName}.${uischema.name}`
    }
    return uischema.name
  }, [isDynamic])

  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = objectPath.get(elementAction, ['isEnable', uischema.key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const [imageSrc, setImageSrc] = useState('')
  const [imageName, setImageName] = useState('')
  const [supportedFile, setSupportedFile] = useState(0)
  const baseUrl = getBaseURL()
  const imageUrl = objectPath.get(action, 'src')
  const dynamicField = objectPath.get(action, 'dynamicField') || null
  const imageFileFormData =
    dynamicField && dynamicField === config?.dynamicKey
      ? dynamicData
      : objectPath.get(formData, uiKey) ||
        objectPath.get(formData, uischema.name)

  const imageFileChanged =
    objectPath.get(isUiChanged, ['files', uiKey]) ||
    objectPath.get(isUiChanged, ['files', uischema.name])

  const [imageFile, setImageFile] = useState(
    actionName === 'url' ? imageUrl : imageFileFormData,
  )

  const isSearch = useMemo(() => checkSearchField(jsonForm, uiKey), [uiKey])

  const updateData = (value) => {
    if (isDynamic) {
      objectPath.set(dynamicData, uiKey, value)
      setFieldFormData(`${dynamicName}.${dynamicIndex}.${uiKey}`, value)
      setFieldAllData(`${dynamicName}.${dynamicIndex}.${uiKey}`, value)
      onUpdateFormData(`${dynamicName}.${dynamicIndex}.${uiKey}`, value)
    } else if (isSearch) {
      setFieldSearchData(uischema, uiKey, value, { isSearch })
      setFieldSearchData(uischema, uiName, value, { isSearch })
      setFieldFormData(uiKey, value)
      setFieldFormData(uiName, value)
      setFieldAllData(uiKey, value)
      setFieldAllData(uiName, value)
      onUpdateFormData(uiName, value, true)
    } else {
      setFieldFormData(uiKey, value)
      setFieldFormData(uiName, value)
      setFieldAllData(uiKey, value)
      setFieldAllData(uiName, value)
      onUpdateFormData(uiName, value)
    }
  }

  useEffect(() => {
    if (imageFileChanged) {
      updateData(imageFileChanged)
      objectPath.del(isUiChanged, ['files', uiKey])
      objectPath.del(isUiChanged, ['files', uischema.name])
      setIsUiChanged(isUiChanged)
    }
  }, [imageFileChanged])

  useEffect(() => {
    if (!imageFileChanged) {
      setImageFile(imageFileFormData)
      setImageSrc('')
      setImageName('')
    }
  }, [imageFileFormData])

  const supportedFileHandler = (event) => {
    setSupportedFile(!!event.target.value)
  }

  const onChangeImage = (e) => {
    e.preventDefault()
    let files = []
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    setImageName(files[0].name)
    objectPath.set(formData, uiKey, files)
    setFormData(formData)
  }

  const createSrc = async (url, filename) => {
    if (!url) return null
    let response = await httpClient
      .get(url)
      .then(() => url)
      .catch(() => '')
    if (response) {
      const blob = await response.blob()
      return new File([blob], filename, {
        type: blob.type,
        lastModified: Date.now(),
      })
    }
    return null
  }

  const checkUrl = async (url) => {
    return await axios
      .get(url)
      .then(() => url)
      .catch(() => '')
  }

  useEffect(async () => {
    let srcImage
    let imageName
    if (actionName === 'originalFile') {
      let mediaAttachmentId = imageFile
      if (mediaAttachmentId) {
        srcImage = `${baseUrl}/media/attachment/originalFile/${mediaAttachmentId}`
      }
    } else if (actionName === 'thumbnail') {
      let mediaAttachmentId = imageFile
      if (mediaAttachmentId) {
        srcImage = `${baseUrl}/media/attachment/thumbnail/${mediaAttachmentId}`
      }
    } else if (actionName === 'url') {
      srcImage = imageFile
    } else if (imageFile) {
      let file =
        objectPath.get(imageFile, `0`) ||
        objectPath.get(imageFile, `imageFile.0`) ||
        objectPath.get(formData, uiKey)
      let mediaAttachmentId = objectPath.get(file, 'attachmentId')
      if (mediaAttachmentId) {
        srcImage = `${baseUrl}/media/attachment/originalFile/${mediaAttachmentId}`
        imageName = objectPath.get(file, 'fileName')
      } else {
        let isFileType = file instanceof File
        if (file && isFileType) {
          let url = URL.createObjectURL(file)
          imageName = objectPath.get(file, `name`)
          srcImage = await checkUrl(url)
        }
      }
    }
    setImageSrc(srcImage)
    setImageName(imageName)
  }, [imageFile])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 mx-0">
        <Label {...props} uischema={uischema} />
        {actionName === 'browse' && (
          <Col className="px-0" sm={12}>
            <div className="custom-file">
              <Form.Control
                type="file"
                className="custom-file-input"
                id={`${fieldKey}-custom-file-input`}
                required
                isInvalid={!supportedFile}
                isValid={supportedFile}
                onChange={(event) => {
                  onChangeImage(event)
                  supportedFileHandler(event)
                }}
                isReadOnly={isReadOnly}
              />
              <Form.Label
                className="custom-file-label"
                htmlFor="validatedCustomFile"
              >
                {imageName ? imageName : 'เลือกไฟล์'}
              </Form.Label>
            </div>
          </Col>
        )}
        <Col sm={uischema.elementWidth} className="px-0">
          {imageSrc ? (
            <Image
              id={`${fieldKey}-image`}
              src={imageSrc}
              style={{
                width: uischema.width,
                height: uischema.height,
                objectFit: uischema.objectFit ? uischema.objectFit : 'contain',
                borderRadius: uischema.shape === 'circle' ? '50%' : '0',
              }}
              alt={imageName}
            />
          ) : (
            <>
              {uischema.defaultImage === 'user' ? (
                <Avatar
                  id={`${fieldKey}-avatar`}
                  className="avatar"
                  variant="rounded"
                  style={{
                    width: uischema.width,
                    height: uischema.height,
                  }}
                />
              ) : (
                <div
                  className="bg-light"
                  style={{
                    width: uischema.width,
                    height: uischema.height,
                    display: 'flex',
                  }}
                ></div>
              )}
            </>
          )}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomImage
